/**
 * admin-chat-modal.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */


import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

import { CollaborationService } from "../intake-form/collaboration.service";

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Administrative Chat
      <span class="badge">
        {{collaboration.users.length}} users
      </span>
    </h4>
  </div>

  <div class="modal-body">
    <p *ngFor="let chat of collaboration.chatMessages" class="report">
      <strong>
        {{chat.author}}
        {{chat.group ? "[" + chat.group + "]" : ""}}
        {{chat.action ? chat.action + "." : ":"}}
      </strong>
      {{chat.message}}
    </p>
    <em
      *ngIf="collaboration.chatMessages.length === 0"
      class="notification">
      No chats since you joined the session.
    </em>
    <em *ngIf="!collaboration.chatEnabled" class="notification">
      Chat is unavailable.
    </em>
  </div>

  <div class="modal-footer">
    <form [formGroup]="form">
      <div class="input-group new-chat">
        <input
          #chatInput
          type="text"
          class="form-control"
          [formControl]="newChat"
          placeholder="Message...">
        <span class="input-group-btn">
          <button
            class="btn btn-primary"
            (click)="sendChat()">
            Send
          </button>
        </span>
      </div>
    </form>
  </div>
  `,
  styles: [".modal-body + .modal-body { border-top: 1px solid #ddd; }"]
})
export class AdminChatModalComponent
  implements ModalComponent<BSModalContext>
{
  public form : FormGroup;
  public newChat : FormControl;

  constructor (
    public dialog : DialogRef<BSModalContext>,
    public collaboration : CollaborationService
  )
  {
    this.newChat = new FormControl("");
    this.form = new FormGroup({newChat: this.newChat});
  }

  public sendChat () : void
  {
    const chat : string = this.newChat.value;
    if (chat !== null && chat.length > 0)
    {
      this.collaboration.sendChat(chat, false).subscribe((sent : boolean) => {
        if (sent)
        {
          // clear the form field now that it has been sent
          this.form.reset();
        }
        else
        {
          alert("Could not send chat message!");
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/administration/admin-chat-modal.component.ts